<template>
  <section
    v-if="points.length"
    class="cc-sheet"
  >
    <header class="cc-sheet__head">
      <h2>{{ $t('convertCoordinates.map.title') }}</h2>
      <p>
        {{ previewNote }}
      </p>
    </header>
    <p
      v-if="error"
      class="cc-inline-error"
    >
      {{ error }}
    </p>
    <div
      ref="mapEl"
      class="cc-map"
    />
  </section>
</template>

<script>
import { loadLeafletAssets } from '@/utils/leafletLoader'
import { BRAND_NAVY, BRAND_LIME } from '@/libs/brandColors'

const PREVIEW_LIMIT = 200

export default {
  name: 'ConvertedPointsMap',
  props: {
    points: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      map: null,
      layer: null,
      error: '',
    }
  },
  computed: {
    previewPoints() {
      return this.points.slice(0, PREVIEW_LIMIT)
    },
    previewNote() {
      if (this.points.length > PREVIEW_LIMIT) {
        return this.$t('convertCoordinates.map.limited', { count: PREVIEW_LIMIT, total: this.points.length })
      }
      return this.$t('convertCoordinates.map.subtitle', { count: this.points.length })
    },
  },
  watch: {
    points: {
      handler() {
        this.$nextTick(() => this.renderMap())
      },
      deep: true,
    },
  },
  mounted() {
    this.renderMap()
  },
  beforeDestroy() {
    this.destroyMap()
  },
  methods: {
    async renderMap() {
      if (!this.previewPoints.length || !this.$refs.mapEl) return
      this.error = ''
      try {
        const L = await loadLeafletAssets()
        if (!this.map) {
          this.map = L.map(this.$refs.mapEl, {
            zoomControl: true,
            attributionControl: false,
          })
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
          }).addTo(this.map)
        }

        if (this.layer) {
          this.map.removeLayer(this.layer)
          this.layer = null
        }

        const markers = this.previewPoints.map(point => (
          L.circleMarker([point.latitude, point.longitude], {
            radius: 6,
            color: BRAND_NAVY,
            weight: 2,
            fillColor: BRAND_LIME,
            fillOpacity: 0.9,
          }).bindPopup(point.name || `${point.latitude}, ${point.longitude}`)
        ))

        this.layer = L.featureGroup(markers).addTo(this.map)
        this.map.fitBounds(this.layer.getBounds().pad(0.2))
        this.$nextTick(() => {
          if (this.map) this.map.invalidateSize()
        })
      } catch (err) {
        this.error = this.$t('convertCoordinates.map.error')
      }
    },
    destroyMap() {
      if (this.map) {
        this.map.remove()
        this.map = null
        this.layer = null
      }
    },
  },
}
</script>
